// 图片基础路径
const IMG_BASE_PATH = window?.tempConfig?.imgUrl;

// 默认标签右侧使用的箭头图标
export const IMG_DEF_TAG_RIGHT_ARROW = IMG_BASE_PATH + "/rightIcon.png";
// 能效等级图标
export const IMG_ENERGYLABEL_LEVEL = IMG_BASE_PATH + "/level/NUMBER.png";

